import { render, staticRenderFns } from "./tab-label.vue?vue&type=template&id=59671f6a&"
import script from "./tab-label.vue?vue&type=script&lang=ts&"
export * from "./tab-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports